import { render, staticRenderFns } from "./FeatureDetailHome.vue?vue&type=template&id=74e48a53&scoped=true&"
import script from "./FeatureDetailHome.vue?vue&type=script&lang=js&"
export * from "./FeatureDetailHome.vue?vue&type=script&lang=js&"
import style0 from "./FeatureDetailHome.vue?vue&type=style&index=0&id=74e48a53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e48a53",
  null
  
)

export default component.exports